{
	"title": "Prosjekter",
	"table": {
		"reference": "Referanse",
		"quantity": "Total mengde",
		"savings": "Totale karbonreduksjoner",
		"fetchError": "Kunne ikke hente prosjekter"
	},
	"showProjectsHistoryTitle": "Vis prosjekthistorikk",
	"noProjects": {
		"createDeclaration": "Lag din første erklæring",
		"description": "Du kan opprette deklarasjoner for ett eller flere materialer ved å klikke på \"Opprett deklarasjon\"."
	}
}
